import React, { useState } from 'react';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import '../../constants/styles/header.scss';

function Header({ setActivePanel, activePanel, endChat, chatEnded, chatStarted, restartChat, isEndChatButtonDisabled, userId, hideWithdrawButton, deleteUser, hashedInput }) {
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [countdown, setCountdown] = useState(5);

    const handleWithdrawClick = () => {
        setShowConfirmDialog(true);
    };

    const handleConfirmWithdraw = () => {
        setCountdown(5);
        const countdownInterval = setInterval(() => {
            setCountdown(prev => {
                if (prev === 1) {
                    clearInterval(countdownInterval);
                    window.location.href = 'https://www.cs.toronto.edu/~brli/summary-study/chatbot.html';
                }
                return prev - 1;
            });
        }, 1000);
    };

    const handleCancelWithdraw = () => {
        setShowConfirmDialog(false);
    };

    return (
        <div className="header">
            <div className="logo-space">
                <SmartToyRoundedIcon className="bot-icon" />
                <h1 className={`logo ${activePanel === 'Current Session' ? 'active' : ''}`}>Intake ChatBot</h1>
            </div>
            <nav>
                {userId && <span className="user-id-display">Participant ID: {userId}</span>}
                {!hideWithdrawButton && <button className="withdraw" onClick={handleWithdrawClick}>Withdraw from Study</button>}
            </nav>

            {showConfirmDialog && (
                <div className="confirm-dialog-overlay">
                    <div className="confirm-dialog">
                        {countdown === 5 ? (
                            <>
                                <p>Are you sure you want to withdraw from the study?</p>
                                <div className="button-container">
                                    <button className="yesButton" onClick={handleConfirmWithdraw}>Yes</button>
                                    <button className="noButton" onClick={handleCancelWithdraw}>No</button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>You have successfully withdrawn from the study.</p>
                                <p>The page will be refreshed in {countdown} seconds.</p>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Header;